export default () => {
    return (
        <h1>About</h1>
    )
}
